import { useLocation } from 'react-router-dom';
import ContactForm from './ContactForm'; // Import your contact form component

function ContactPage() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isSuccess = searchParams.get("form") === "success";

    return (
        <div className="flex flex-col justify-center items-center setup-guide bg-dark-blue text-gray-300 p-4 h-full w-[100em] pb-10">
            <div className="max-w-[70em]">
                <div className="flex flex-col w-full bg-dark-blue">
                    {isSuccess && <p>Thank you for your submission! We will get back to you shortly.</p>}
                    {!isSuccess && <ContactForm />} </div>
            </div>
        </div>
    );
}

export default ContactPage;
